<script>
    import Header from '../global/header.svelte'
    import Footer from '../global/footer.svelte'
</script>

<style>


    section {
        text-align: center;
    }

    h1 {
        font-size:27px;
        font-size: 2.7rem;
        line-height: 27px;
        font-weight: 300;
    }

    section > div {
        padding: 5vw;
        min-height: 60vh;
        display: flex;
        align-items: center;
        justify-content: center; 
    }

    .btn {
        max-width: 200px;
        margin: 10px auto 0 auto;
    }
   

</style>


<svelte:head>
    <title>Error</title>
</svelte:head>

<Header title="Error" url="/" /> 

<section>
    <div>
        <div>
            <h1>Whoops</h1>
            <p>There has been an error contacting the server. Please click back and try again.</p>
             <a class="btn" href="/">Back Home</a>
        </div>
    </div>
</section>

<Footer />
